import src from "IMAGE";
export default { src, width: 240, height: 240, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRmYAAABXRUJQVlA4TFkAAAAvB8ABAM1VICICHgiwDQMAAICkvbrhAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGYD3bWv7QAAiIjsHw7XmHuskEvbLQHRomPLOz1R4UlDKZIFqj0/AwA="};
